







import { defineComponent, inject } from '@vue/composition-api';
import { StatusBoardStoreModule, StatusBoardStoreModuleKey } from '@/modules/statusBoard/store';

export default defineComponent({

  setup () {
    const store = inject(StatusBoardStoreModuleKey) as StatusBoardStoreModule;
    return {
      create: async () => { await store.createCharacter('新規キャラクター'); }
    };
  }
});
